import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Params, RedirectCommand, RouterStateSnapshot, UrlSerializer } from "@angular/router";
import { LocaleService } from "./core/locale/locale.service";

@Injectable({
  providedIn: 'root'
})
export class LanguageGuard implements CanActivate {
  constructor(
    private localeService: LocaleService,
    private urlSerializer: UrlSerializer,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const lang = route.params['lang']

    // check language and optionally change the language
    const culture = this.localeService.supported.find(s => s.language === lang)
    if (culture) {
      if (culture.language !== this.localeService.currentLang())
        this.localeService.setCultureAsync(culture.culture)

      return true
    }

    // Redirect /Raum/Tenant to url without /Raum
    if (route.params['catalog'] === 'Raum') {
      const urlTree = this.urlSerializer.parse(`/${route.params['lang']}/${this.localeService.currentLang()}`)
      urlTree.queryParams = route.queryParams
      return new RedirectCommand(urlTree)
    }

    // Redirect URLs like /Tenant/Warenkorb to /Tenant/de/cart
    switch (lang.toLowerCase()) {
      case 'warenkorb':
      case 'cart':
        return this.redirectWithLangPrefix(route.params, state, 'cart')
      case 'bestellung':
      case 'checkout':
        return this.redirectWithLangPrefix(route.params, state, 'checkout')
      case 'agb':
      case 'rechtliches':
      case 'terms-and-conditions':
        return this.redirectWithLangPrefix(route.params, state, 'terms-and-conditions')
      case 'login':
        return this.redirectWithLangPrefix(route.params, state, 'login')
      case 'coupon':
        return this.redirectWithLangPrefix(route.params, state, 'coupon')
      case 'order-success':
      case 'ordersuccess':
        return this.redirectWithLangPrefix(route.params, state, 'order-success')
      case 'pw-reset':
      case 'pwreset':
        return this.redirectWithLangPrefix(route.params, state, 'pw-reset')
      default:
        return true
    }
  }

  // redirect routes without language-prefix to routes with language prefix
  private redirectWithLangPrefix(params: Params, state: RouterStateSnapshot, newKeyword: string) {
    const find = `/${params['catalog']}/${params['lang']}`
    const replace = `/${params['catalog']}/${this.localeService.currentLang()}/${newKeyword}`
    const newUrl = state.url.replace(find, replace)

    return new RedirectCommand(this.urlSerializer.parse(newUrl))
  }
}
